import { useMemo } from 'react';
import { conditionExistsInQuery } from 'modules/queryBuilder/utils';
import { usePermissionsContext } from '../contexts/permissions';
import { useSegmentationQueryContext } from '../contexts/segmentationQuery';
import { hasCatalogQuery } from '../utils';

export const useIsCatalogSaveRestricted = () => {
  const { canSaveDynamicListWithCatalog } = usePermissionsContext();
  const { searchQuery } = useSegmentationQueryContext();

  return useMemo(() => {
    return conditionExistsInQuery(searchQuery, hasCatalogQuery) && !canSaveDynamicListWithCatalog;
  }, [searchQuery, hasCatalogQuery, canSaveDynamicListWithCatalog]);
};
